'use client';

import React, { useEffect, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useAuth } from './KeycloakProvider';
import PageLoader from './PageLoader';

// /connect presents its own mapped-customer sign-in; its APIs remain protected.
const PUBLIC_PATHS = ['/login', '/signup', '/verify-email', '/forgot-password', '/reset-password', '/connect'];

export function AuthGuard({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const router = useRouter();
  const { authenticated } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const isPublic = PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(path + '/'));

    if (isPublic) {
      setChecking(false);
      return;
    }

    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('scalesutra_token');
      if (!token && !authenticated) {
        const destination = `${window.location.pathname}${window.location.search}`;
        router.replace(`/login?redirect=${encodeURIComponent(destination)}`);
        return;
      }
    }
    setChecking(false);
  }, [pathname, authenticated, router]);

  if (checking && !PUBLIC_PATHS.some((path) => pathname === path)) {
    return <PageLoader type="full" title="Verifying security permissions..." />;
  }

  return <>{children}</>;
}
